
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import store from '@/store';
import { SubscriptionState } from '@/classes/stripe';

@Component({
  computed: {
    ...mapState<SubscriptionState>('subscription', {
      showLoadingSubscription: (state: SubscriptionState) => state.showLoading,
    }),
  },
})
export default class ReactivateSubscription extends Vue {
  @Prop(Boolean)
  open!: boolean;

  @Prop()
  renew!: string;

  // DATA
  // mapState
  showLoadingSubscription!: any;
  activeSubscription = store.state.subscription.activeSubscription;

  // DATA END

  // METHODS
  onReactivateSubscription(planId: string) {
    if (!this.activeSubscription.id) {
      return;
    }

    store
      .dispatch('subscription/reactivateSubscription', planId)
      .then(() => {
        store.dispatch('subscription/setActiveSubscription', this.activeSubscription);
        this.$emit('reactivate');
        this.$emit('cancel');
      })
      .catch(() => {
        this.$emit('cancel');
        store.dispatch('layout/setSnackbar', {
          type: 'error',
          icon: 'forbidden-system',
          text: this.$t('fields.account.billing.reactivate_subs.snackbar_error').toString(),
          isSnackbar: true,
        });
      });
  }

  cancel() {
    this.$emit('cancel');
  }
  // METHODS END

  // COMPUTED METHODS
  // COMPUTED METHODS END

  // WATCHERS
  @Watch('open')
  onOpenChange(open: boolean) {
    if (!open) {
      return;
    }
  }
  // WATCHERS END
}
